const CHInjections = () => {
	return (
		<>
			<path
				d="M9.65001 16.64C13.98 11.26 19.58 14.34 19.21 20.68C18.65 30.13 -0.689993 29.48 9.65001 16.64Z"
				fill="#F7D9D8"
			/>
			<path
				d="M6.08999 27.9C5.96999 27.9 5.83999 27.85 5.73999 27.76C5.53999 27.57 5.52999 27.25 5.72999 27.05C6.68999 26.05 7.10999 25.66 7.51999 25.28C7.93999 24.89 8.33999 24.53 9.32999 23.48C9.51999 23.28 9.88999 23.22 10.09 23.41C10.29 23.6 10.35 23.86 10.16 24.06C10.16 24.06 10.1 24.12 10.09 24.13C9.03999 25.24 8.62999 25.62 8.18999 26.02C7.78999 26.39 7.37999 26.76 6.43999 27.75C6.33999 27.85 6.20999 27.9 6.07999 27.9H6.08999Z"
				fill="#C68486"
			/>
			<path
				d="M10.39 24.39C10.09 24.39 9.81 24.32 9.53 24.14C9.3 23.99 9.23 23.68 9.38 23.45C9.53 23.22 9.84 23.15 10.07 23.3C10.54 23.6 11.32 23.12 12.22 22.57C12.76 22.24 13.31 21.9 13.91 21.65L23.84 11.36C24.03 11.16 24.35 11.16 24.55 11.35C24.75 11.54 24.76 11.86 24.56 12.06L14.38 22.54C13.82 22.76 13.27 23.09 12.74 23.42C11.95 23.9 11.15 24.39 10.39 24.39Z"
				fill="#C68486"
			/>
			<path
				d="M25.19 12.78C25.06 12.78 24.94 12.73 24.84 12.64L20.55 8.39998C20.35 8.20998 20.35 7.88998 20.55 7.68998C20.74 7.48998 21.06 7.48998 21.26 7.68998L25.55 11.93C25.75 12.12 25.75 12.44 25.55 12.64C25.45 12.74 25.32 12.79 25.19 12.79V12.78Z"
				fill="#C68486"
			/>
			<path
				d="M14.22 22.19C14.1 22.19 13.98 22.15 13.88 22.06L11.28 19.66C11.08 19.47 11.06 19.16 11.25 18.95C11.44 18.75 11.75 18.73 11.96 18.92L14.56 21.32C14.76 21.51 14.78 21.82 14.59 22.03C14.49 22.14 14.36 22.19 14.22 22.19Z"
				fill="#C68486"
			/>
			<path
				d="M9.76 24.17C9.56 24.17 9.38 24.06 9.32 23.85C8.74 22.88 9.51 21.72 10.25 20.61C10.58 20.11 10.93 19.59 11.16 19.09L11.26 18.95C13.47 16.73 15.7 14.54 17.94 12.34L21.41 8.93001C21.61 8.74001 21.92 8.74001 22.12 8.93001C22.31 9.13001 22.31 9.44001 22.12 9.64001L18.65 13.05C16.44 15.22 14.23 17.39 12.04 19.59C11.78 20.13 11.43 20.65 11.09 21.16C10.52 22.01 9.93 22.9 10.21 23.35L10.26 23.48C10.33 23.75 10.19 24.07 9.92 24.14C9.87 24.15 9.81 24.16 9.76 24.16V24.17Z"
				fill="#C68486"
			/>
			<path
				d="M23.98 11.16C23.85 11.16 23.72 11.11 23.62 11.01C23.43 10.81 23.43 10.5 23.62 10.3L26.52 7.46C26.72 7.27 27.04 7.27 27.23 7.46C27.42 7.66 27.42 7.97 27.23 8.17L24.33 11.01C24.23 11.11 24.11 11.15 23.98 11.15V11.16Z"
				fill="#C68486"
			/>
			<path
				d="M27.92 8.91998C27.8 8.91998 27.67 8.86998 27.57 8.77998L24.63 5.96998C24.43 5.77998 24.42 5.45998 24.61 5.25998C24.8 5.05998 25.12 5.04998 25.32 5.23998L28.26 8.04998C28.46 8.23998 28.47 8.55998 28.28 8.75998C28.18 8.85998 28.05 8.90998 27.92 8.90998V8.91998Z"
				fill="#C68486"
			/>
			<path
				d="M22.77 10.03C22.64 10.03 22.51 9.98002 22.41 9.88002C22.22 9.68002 22.22 9.37002 22.41 9.17002L25.34 6.29002C25.54 6.10002 25.86 6.10002 26.05 6.29002C26.24 6.49002 26.24 6.80002 26.05 7.00002L23.12 9.88002C23.02 9.98002 22.9 10.02 22.77 10.02V10.03Z"
				fill="#C68486"
			/>
		</>
	);
};

export default CHInjections;
